var icon = require('vue-svgicon')
icon.register({
  'ks-icon-user': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<defs><symbol id="svgicon-a" data-name="account" viewBox="0 0 16 16"><path pid="0" d="M8 0a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H0v-2c0-2.21 3.58-4 8-4z"/></symbol></defs><use width="16" height="16" transform="matrix(5.25 0 0 5.25 22 22)" xlink:href="#svgicon-a"/>'
  }
})
